module.exports = __webpack_public_path__ + "img/admin-feature-orderonpage.e6a66d22.png";